'use strict';

module.exports = ['translationService', function (translationService) {

	/**
	 * actual filter which translates the string
	 * @param stringToBeTranslated
	 * @returns {*}
	 */
	function translateString(stringToBeTranslated){
		return translationService.translate(stringToBeTranslated);
	}

	/**
	 * tells angular to check the filter every digest cycle
	 */
	checkAvailability.$stateful = true;

	function insertParams(stringToBeTranslated, params = {}){
		if(params){
			for (let key in params){
				stringToBeTranslated = stringToBeTranslated.split(`[[${key}]]`).join(params[key]);
			}
		}

		return stringToBeTranslated;
	}

	/**
	 * checks the availability of the translations.
	 * @param stringToBeTranslated
	 * @param params
	 * @returns {*}
	 */
	function checkAvailability(stringToBeTranslated, params){
		if(translationService.isTranslationAvailable() === false){
			return insertParams(stringToBeTranslated, params);
		} else {
			return insertParams(translateString(stringToBeTranslated), params);
		}
	}

	return checkAvailability
}]
